import { Row, Col } from "antd";
// ...existing code...

import footerContent from "../../content/FooterContent.json";
import { APP_VERSION } from "../../common/version";

import { FooterSection } from "./styles";

// interface SocialLinkProps {
//   href: string;
//   src: string;
// }

const Footer = () => {
  // ...existing code...


  return (
    <FooterSection>
      <Row align="middle" justify="start" gutter={[32, 24]} style={{ flexWrap: 'wrap' }}>
        <Col lg={6} md={8} sm={24} xs={24} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
          <img src="/img/logo-transparent.png" alt="Royal Finish Logo" style={{ width: '240px', maxWidth: '100%' }} />
        </Col>
        <Col lg={12} md={8} sm={24} xs={24} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16, height: '100%' }}>
          <div style={{ fontSize: 18, color: '#fff', lineHeight: 1.6, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: '120px', textAlign: 'center' }}>
            <span style={{ width: '100%' }}>{footerContent.message}</span>
          </div>
        </Col>
        <Col lg={6} md={8} sm={24} xs={24} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 16 }}>
          <h4 style={{ color: '#fff', fontSize: 22, marginBottom: 12, textAlign: 'center' }}>Contact Info</h4>
          <div style={{ color: '#fff', fontSize: 16, marginBottom: 8, textAlign: 'center' }}>
            <strong>Email:</strong> <a href={`mailto:${footerContent.email}`} style={{ color: '#fff', textDecoration: 'none' }}>{footerContent.email}</a>
          </div>
          <div style={{ color: '#fff', fontSize: 16, textAlign: 'center' }}>
            <strong>Phone:</strong> <a href={`tel:${footerContent.phone.replace(/[^\d]/g, '')}`} style={{ color: '#fff', textDecoration: 'none' }}>{footerContent.phone}</a>
          </div>
        </Col>
      </Row>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
        <span style={{ color: '#fff', fontSize: 12, opacity: 0.08, pointerEvents: 'none', userSelect: 'none', marginRight: 24 }}>v {APP_VERSION}</span>
      </div>
    </FooterSection>
  );
};

export default Footer;
